import React, { useMemo } from 'react';
import ResumenInformacionBasica from './components/ResumenInformacionBasica';
import ResumenConfiguracion from './components/ResumenConfiguracion';
import ResumenPreguntas from './components/ResumenPreguntas';
import './Step4Revision.css';

/**
 * Paso 4: Revisión Final de la Evaluación
 * Componente refactorizado con arquitectura modular
 * Muestra un resumen completo de todos los datos antes de guardar
 * 
 * Props:
 * - formData: Datos completos del formulario
 * - tiposPrueba: Array de tipos de evaluación disponibles
 * - tiposCargo: Array de tipos de cargo disponibles  
 * - cargosEspecificos: Array de cargos específicos disponibles
 * - isEditMode: Indica si está en modo edición o creación
 * - onEdit: Callback para volver a editar (recibe el número de paso)
 */
const Step4Revision = ({
  formData,
  tiposPrueba = [],
  tiposCargo = [],
  cargosEspecificos = [],
  isEditMode = false,
  onEdit = () => {}
}) => {
  // Memoizar cálculos para optimizar rendimiento
  const datosCalculados = useMemo(() => {
    const tipoEvaluacion = tiposPrueba.find(t => t.value == formData.tipoPrueba);
    const tipoCargo = tiposCargo.find(t => t.value == formData.idTipoCargo);
    const cargosSeleccionados = cargosEspecificos.filter(cargo => 
      formData.cargosSeleccionados.includes(cargo.value)
    );
    
    const totalPreguntas = formData.preguntas?.length || 0;
    const totalOpciones = formData.preguntas?.reduce((total, p) => total + (p.opciones?.length || 0), 0) || 0;
    const puntajeTotal = formData.puntajeTotal || 0;
    
    return {
      tipoEvaluacion,
      tipoCargo,
      cargosSeleccionados,
      totalPreguntas,
      totalOpciones,
      puntajeTotal
    };
  }, [formData, tiposPrueba, tiposCargo, cargosEspecificos]);

  return (
    <div className="step4-container">

      <div className="step4-card">
        <div className="row">
          <div className="col-12">
            <div className="text-center mb-4">
              <h4 className="text-primary">
                <i className="fas fa-clipboard-check me-2"></i>
                Revisión Final - {isEditMode ? 'Editar' : 'Crear'} Evaluación
              </h4>
              <p className="text-muted">
                Verifique todos los datos antes de {isEditMode ? 'actualizar' : 'crear'} la evaluación
              </p>
            </div>

            {/* Resumen de información básica */}
            <ResumenInformacionBasica
              formData={formData}
              tipoEvaluacion={datosCalculados.tipoEvaluacion}
              tipoCargo={datosCalculados.tipoCargo}
              cargosSeleccionados={datosCalculados.cargosSeleccionados}
              onEdit={onEdit}
            />

            {/* Resumen de configuración */}
            <ResumenConfiguracion
              formData={formData}
              puntajeTotal={datosCalculados.puntajeTotal}
              onEdit={onEdit}
            />

            {/* Resumen de preguntas */}
            <ResumenPreguntas
              preguntas={formData.preguntas}
              totalPreguntas={datosCalculados.totalPreguntas}
              totalOpciones={datosCalculados.totalOpciones}
              puntajeTotal={datosCalculados.puntajeTotal}
              onEdit={onEdit}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Step4Revision;
